import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import keycode from 'keycode';
import Table, {
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
} from 'material-ui/Table';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Paper from 'material-ui/Paper';
import Checkbox from 'material-ui/Checkbox';
import IconButton from 'material-ui/IconButton';
import Tooltip from 'material-ui/Tooltip';
import DeleteIcon from 'material-ui-icons/Delete';
import {get} from 'engine/dataServices';
import jMoment from 'moment-jalaali';
import ContainerHeader from 'components/ContainerHeader/index';
import Loader from 'react-loader-spinner';


let counter = 0;

function createData(name, calories, fat, carbs, protein) {
    counter += 1;
    return {id: counter, name, calories, fat, carbs, protein};
}

const columnData = [
    {id: 'TransactionId', numeric: false, disablePadding: true, label: 'َشناسه'},
    {id: 'InApp_Title', numeric: false, disablePadding: true, label: 'عنوان آیتم فروخته شده'},
    {id: 'Status', numeric: false, disablePadding: true, label: 'وضعیت تراکنش'},
    {id: 'Price', numeric: false, disablePadding: true, label: 'مبلغ تراکنش'},
    {id: 'UserName', numeric: false, disablePadding: true, label: 'شناسه کاربر'},
    {id: 'UserIp', numeric: false, disablePadding: true, label: 'Ip کاربر'},
    {id: 'IMEI', numeric: false, disablePadding: true, label: 'شناسه دستگاه کاربر(IMEI)'},
    {id: 'CreatedDate', numeric: false, disablePadding: true, label: 'تاریخ شروع تراکنش'},
    {id: 'DateModified', numeric: false, disablePadding: true, label: 'تاریخ اتمام تراکنش'},
    {id: 'BankRefrenceId', numeric: false, disablePadding: true, label: 'کد پیگیری بانک'},
];

class DataTableHead extends React.Component {

    static propTypes = {
        numSelected: PropTypes.number.isRequired,
        onRequestSort: PropTypes.func.isRequired,
        onSelectAllClick: PropTypes.func.isRequired,
        order: PropTypes.string.isRequired,
        orderBy: PropTypes.string.isRequired,
        rowCount: PropTypes.number.isRequired,
    };

    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const {onSelectAllClick, order, orderBy, numSelected, rowCount} = this.props;

        return (
            <TableHead>
                <TableRow>
{/*                    <TableCell padding="checkbox">
                        <Checkbox
                            indeterminate={numSelected > 0 && numSelected < rowCount}
                            checked={numSelected === rowCount}
                            onChange={onSelectAllClick}
                        />
                    </TableCell>*/}
                    {columnData.map(column => {
                        return (
                            <TableCell
                                key={column.id}
                                numeric={column.numeric}
                                padding={column.disablePadding ? 'none' : 'default'}
                                className='text-center'
                            >
                                <Tooltip
                                    title="Sort"
                                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === column.id}
                                        direction={order}
                                        onClick={this.createSortHandler(column.id)}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}


let DataTableToolbar = props => {
    const {numSelected} = props;

    return (
        <Toolbar
            className={classNames("table-header", {
                ["highlight-light"]: numSelected > 0,
            })}
        >
            <div className="title">
                {numSelected > 0 ? (
                    <Typography type="subheading">{numSelected} ردیف انتخاب شده</Typography>
                ) : (
                    <Typography type="title">تاریخچه ریز گزارشات خرید و فروش های انجام شده</Typography>
                )}
            </div>
            <div className="spacer"/>
            <div className="actions">
                {numSelected > 0 && (
                    <Tooltip title="Delete">
                        <IconButton aria-label="Delete">
                            <DeleteIcon/>
                        </IconButton>
                    </Tooltip>
                )}
            </div>
        </Toolbar>
    );
};

DataTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};


class Index extends React.Component {
    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        const data =
            order === 'desc'
                ? this.state.data.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
                : this.state.data.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));

        this.setState({data, order, orderBy});
    };
    handleSelectAllClick = (event, checked) => {
        if (checked) {
            this.setState({selected: this.state.data.map(n => n.id)});
            return;
        }
        this.setState({selected: []});
    };
    handleKeyDown = (event, id) => {
        if (keycode(event) === 'space') {
            this.handleClick(event, id);
        }
    };
    handleClick = (event, id) => {
        const {selected} = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        this.setState({selected: newSelected});
    };
    handleChangePage = (event, page) => {
        this.setState({page});
    };
    handleChangeRowsPerPage = event => {
        this.setState({rowsPerPage: event.target.value});
    };
    isSelected = id => this.state.selected.indexOf(id) !== -1;


    componentWillMount(){
        console.log("will mount");
    }

    constructor(props) {
        super(props);

        this.props.handleLoading(true);

        this.loadData();

        this.state = {
            order: 'asc',
            orderBy: 'calories',
            selected: [],
            data: [],
            page: 0,
            rowsPerPage: 5,
        };
    }

    async loadData() {
        let response = await get('/api/Transaction/Get?developerId=7');
        if(response.status === 200){
            let _data = await response.json();
            this.setState({data: _data});
        }
        this.props.handleLoading(false);
    }

    render() {
        const {data, order, orderBy, selected, rowsPerPage, page} = this.state;

        return (
            <div>
                {/* Inja BreakCrumb ezafeh shode , agar baad az etesal Hanooz Error Dasht Shayad Marboot Be In Moerd Bashe */}

                <ContainerHeader match={this.props.match} title="تراکنش های انجام شده"/>
                <Paper>
                    <DataTableToolbar numSelected={selected.length}/>
                    <div className="flex-auto">
                        <div className="table-responsive-material">
                            <Table className="">
                                <DataTableHead
                                    numSelected={selected.length}
                                    order={order}
                                    orderBy={orderBy}
                                    onSelectAllClick={this.handleSelectAllClick}
                                    onRequestSort={this.handleRequestSort}
                                    rowCount={data.length}
                                />
                                <TableBody>
                                    {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {
                                        const isSelected = this.isSelected(n.id);
                                        return (
                                            <TableRow
                                                hover
                                                onClick={event => this.handleClick(event, n.id)}
                                                onKeyDown={event => this.handleKeyDown(event, n.id)}
                                                role="checkbox"
                                                aria-checked={isSelected}
                                                tabIndex={-1}
                                                key={n.id}
                                                selected={isSelected}
                                            >
                                                {/*<TableCell padding="checkbox">
                                                    <Checkbox checked={isSelected}/>
                                                </TableCell>*/}
                                                <TableCell padding="none"
                                                           className="text-center">{n.TransactionId}</TableCell>
                                                <TableCell padding="none"
                                                           className="text-center">{n.InApp_Title}</TableCell>
                                                <TableCell padding="none" className="text-center">{(n.Status) ? 'موفق' : 'ناموفق'}</TableCell>
                                                <TableCell padding="none" className="text-center">{n.Price}</TableCell>
                                                <TableCell padding="none"
                                                           className="text-center">{n.UserName}</TableCell>
                                                <TableCell padding="none" className="text-center">{n.UserIp}</TableCell>
                                                <TableCell padding="none" className="text-center">{n.IMEI}</TableCell>
                                                <TableCell
                                                    padding="none"
                                                    className="text-center">{jMoment(n.CreatedDate).format('jYYYY/jM/jD')}</TableCell>
                                                <TableCell
                                                    padding="none"
                                                    className="text-center">{(n.DateModified) ? jMoment(n.DateModified).format('jYYYY/jM/jD') : 'به اتمام نرسیده'}</TableCell>
                                                <TableCell padding="none"
                                                           className="text-center">{n.BankRefrenceId}</TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            count={data.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </div>
                    </div>
                </Paper>
            </div>
        );
    }
}

export default Index;



// WEBPACK FOOTER //
// ./app/routes/apall/Transactions/index.js